import { AnchorLink } from 'components/anchorLink/AnchorLink';
import { CarrelloFooterSimpleInfoRow } from 'features/carrello/carrelloFooter/carrelloFooterSimpleInfoRow';
import styles from './CarrelloFooterPrenotazioni.module.scss';
import { useGetLabelByKey } from 'hooks/useLingUI';

export type CarrelloFooterPrenotazioniProps = {
  totale: number;
  puntata: number;
  vincitaPotenziale: number;
  linkTrovaPuntoSnai: string;
  idPrenotazione: string;
  codiceSessione: string;
  removePrenotazione: Function;
};

export const CarrelloFooterPrenotazioni = ({
  totale,
  puntata,
  vincitaPotenziale,
  linkTrovaPuntoSnai,
  idPrenotazione,
  codiceSessione,
  removePrenotazione,
}: CarrelloFooterPrenotazioniProps) => {
  const labelQuotaTotale = useGetLabelByKey('quota-totale');
  const labelPuntata = useGetLabelByKey('puntata');
  const labelVincitaPotenziale = useGetLabelByKey('vincita-potenziale');
  const labelTrovaPuntoSnai = useGetLabelByKey('trova-punto-snai');
  const labelAnnullaPrenotazione = useGetLabelByKey('annulla-prenotazione');
  return (
    <div className={styles.container}>
      <CarrelloFooterSimpleInfoRow label={labelQuotaTotale!} value={String(totale)} />
      <CarrelloFooterSimpleInfoRow label={labelPuntata!} value={String(puntata)} hasBorder={true} />
      <CarrelloFooterSimpleInfoRow label={labelVincitaPotenziale!} value={String(vincitaPotenziale)} />
      <AnchorLink
        href={linkTrovaPuntoSnai}
        isButton={true}
        visualizationType="primary"
        target="_blank"
        className={styles.trovaPuntoSnai}
        size={'medium'}
      >
        {labelTrovaPuntoSnai}
      </AnchorLink>
      <button className={styles.button} onClick={() => removePrenotazione(codiceSessione, idPrenotazione)}>
        {labelAnnullaPrenotazione}
      </button>
      {/* */}
    </div>
  );
};

CarrelloFooterPrenotazioni.defaultProps = {
  linkTrovaPuntoSnai: '/geolocator',
};
